export const handleClickTop = () => {
  window.scrollTo(0, 0);
};
